module.exports = __webpack_public_path__ + "img/technology.19208734.jpg";